import { useState, type FormEvent } from 'react';
import { Navigate } from 'react-router-dom';
import { ValidationError, isDomainError } from '@domain/errors';
import { useAuth } from '../providers/auth-context';

export function LoginPage(): JSX.Element {
  const { status, signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [fields, setFields] = useState<Record<string, string>>({});

  if (status === 'authenticated') return <Navigate to="/" replace />;

  const handleSubmit = async (event: FormEvent): Promise<void> => {
    event.preventDefault();
    setBusy(true);
    setMessage(null);
    setFields({});
    try {
      await signIn(email, password);
    } catch (error) {
      if (error instanceof ValidationError) setFields({ ...error.fields });
      setMessage(isDomainError(error) ? error.message : 'Connexion impossible.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#F4F6F9',
        padding: 16,
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          width: 380,
          maxWidth: '100%',
          background: '#fff',
          borderRadius: 20,
          padding: '40px 36px',
          boxShadow: '0 24px 60px -24px rgba(51,80,107,0.35)',
          border: '1px solid #E4E8ED',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <img
            src="/logo.png"
            alt="BabiMams"
            style={{ width: 96, height: 96, objectFit: 'cover', borderRadius: '50%' }}
          />
          <h1
            style={{
              fontFamily: "'Baloo 2', sans-serif",
              fontSize: 24,
              color: '#233A50',
              fontWeight: 700,
              margin: '12px 0 0',
            }}
          >
            BabiMams Admin
          </h1>
          <p style={{ fontSize: 14, color: '#6B7785', margin: '4px 0 0' }}>
            Back-office de modération
          </p>
        </div>

        <label className="bbm-label" htmlFor="login-email">
          Adresse e-mail
        </label>
        <input
          id="login-email"
          type="email"
          autoComplete="username"
          className="bbm-field"
          style={{ marginBottom: fields.email ? 4 : 16 }}
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
        {fields.email ? <div className="bbm-error-text">{fields.email}</div> : null}

        <label className="bbm-label" htmlFor="login-password">
          Mot de passe
        </label>
        <input
          id="login-password"
          type="password"
          autoComplete="current-password"
          className="bbm-field"
          style={{ marginBottom: fields.password ? 4 : 22 }}
          value={password}
          onChange={(event) => setPassword(event.target.value)}
        />
        {fields.password ? <div className="bbm-error-text">{fields.password}</div> : null}

        {message ? (
          <div className="bbm-error-text" role="alert" style={{ margin: '0 0 14px' }}>
            {message}
          </div>
        ) : null}

        <button
          type="submit"
          disabled={busy}
          style={{
            width: '100%',
            padding: 12,
            border: 'none',
            borderRadius: 10,
            background: '#D67F9E',
            color: '#fff',
            fontSize: 15,
            fontWeight: 700,
          }}
        >
          {busy ? 'Connexion…' : 'Se connecter'}
        </button>

        <p style={{ fontSize: 12, color: '#8A95A3', marginTop: 16, textAlign: 'center' }}>
          Accès selon vos droits. En mode démo, un e-mail commençant par « mod » ouvre une session
          admin, tout autre e-mail ouvre une session super-admin.
        </p>
      </form>
    </div>
  );
}
